import Config from '../../Config';
import EpiContext from '@episerver/spa-core/Spa';

export function replaceVariablesInBrackets(str) {
  for (let i = 1; i <= arguments.length; i++) {
    str = str.replace('{' + (i - 1) + '}', arguments[i]);
  }
  return str;
}

export function minutesToHHMM(min) {
  var hours = Math.floor(min / 60);
  var minutes = Math.floor(min - (hours * 3600) / 60);
  if (hours < 10) {
    hours = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  return hours + ':' + minutes;
}

/** EPI Url property: Page Reference has value.url, External URL has value as string (or value.href) */
export function getUrlFromEpiLink(linkProp) {
  const v = linkProp?.value;
  if (!v) return undefined;
  if (typeof v === 'string') return v;
  return v?.url ?? v?.href;
}

export function validURL(str) {
  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ); // fragment locator
  return !!pattern.test(str);
}
export function parseStyleString(styleString) {
  if (!styleString) return {};
  return styleString.split(';').reduce((acc, style) => {
    const [key, value] = style.split(':').map((s) => s && s.trim());
    if (key && value) {
      // convert CSS property to camelCase
      const camelKey = key.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
      acc[camelKey] = value;
    }
    return acc;
  }, {});
}

export function isValidILMobile(number) {
  const mobileNumberRegex = /^05\d{8}$/;
  return mobileNumberRegex.test(number.trim());
}

export function isValidILMobileExtended(number) {
  // Supports both regular mobile (05...) and data-only numbers (130...)
  const mobileNumberRegex = /^(05\d{8}|130\d{7})$/;
  return mobileNumberRegex.test(number.trim());
}

export function getMobileNumSeparatedByDash(mobileNum = '') {
  return mobileNum.length == 10 ? `${mobileNum.slice(0, 3)}-${mobileNum.slice(3)}` : mobileNum;
}

export async function handleURL(url, context) {
  if (validURL(url)) {
    let win = window.open(url, '_blank');
    win.focus();
  } else {
    let content = await context.loadContentByPath(url);
    context.navigateTo(content);
  }
}

export async function prepareUrl(url, context) {
  if (!validURL(url)) {
    if (url.startsWith('/globalassets')) {
      url = context.getEpiserverUrl() + url;
    } else {
      //url = Config.staticWebSiteUrl + url;
      let content = await context.loadContentByPath(url);
      context.navigateTo(content);
      return;
    }
  }
  let win = window.open(url, '_blank');
  win.focus();
}

export function buildUrl(url) {
  if (!url) {
    return '';
  }
  let fullUrl = '';

  if (url.startsWith('http')) {
    return url;
  }

  if (url.startsWith('/globalassets') || url.endsWith('.aspx')) {
    fullUrl = Config.epiBaseUrl + url;
  } else {
    fullUrl = Config.staticWebSiteUrl + url;
  }
  return fullUrl;
}

export async function prepareNewWindowUrl(url, context) {
  if (!validURL(url)) {
    if (url.startsWith('/globalassets')) {
      url = context.getEpiserverUrl() + url;
    } else {
      let content = await context.loadContentByPath(url);
      url = Config.staticWebSiteUrl + content.url;
    }
  }
  let win = window.open(url, '_blank');
  win.focus();
}

export function prepareSameWindowUrlWithNavigateTo(url, context = EpiContext) {
  if (!validURL(url)) {
    context.navigateTo(url);
    return;
  }
  let win = window.open(url, '_self');
  win.focus();
}

export async function prepareSameWindowUrl(url, context) {
  if (!validURL(url)) {
    if (url.startsWith('/globalassets')) {
      url = context.getEpiserverUrl() + url;
    } else {
      let content = await context.loadContentByPath(url);
      url = Config.staticWebSiteUrl + content.url;
    }
  }
  let win = window.open(url, '_self');
  win.focus();
}

export async function buildUrlAndOpenWindow(url) {
  if (!validURL(url)) {
    if (url.startsWith('/globalassets')) {
      url = EpiContext.getEpiserverUrl() + url;
    } else {
      let content = await EpiContext.loadContentByPath(url);
      url = Config.staticWebSiteUrl + content.url;
    }
  }
  let win = window.open(url, '_blank');
  win.focus();
}

export async function buildUrlOpenPageSelfAndRestBlank(url) {
  let isEpiPageType = false;
  if (!validURL(url)) {
    if (url.startsWith('/globalassets')) {
      url = EpiContext.getEpiserverUrl() + url;
    } else {
      let content = await EpiContext.loadContentByPath(url);
      url = Config.staticWebSiteUrl + content.url;
      isEpiPageType = true;
    }
  }
  let win = window.open(url, isEpiPageType ? '_self' : '_blank');
  win.focus();
}

export async function buildUrlAndOpenSameWindow(url) {
  if (url.startsWith(Config.staticWebSiteUrl)) {
    const relativeUrl = url.replace(Config.staticWebSiteUrl, '');
    EpiContext.navigateTo(relativeUrl).then(() => {
      if (typeof window.scrollTo === 'function') {
        window.scrollTo(0, 0);
      }
    });
    return;
  }
  if (!validURL(url)) {
    const relativeUrl = url?.toLowerCase();
    if (relativeUrl.includes('/globalassets') || relativeUrl.includes('/contentassets')) {
      url = EpiContext.getEpiserverUrl() + url;
    } else {
      let content = await EpiContext.loadContentByPath(url);
      url = Config.staticWebSiteUrl + content.url;
    }
  }
  let win = window.open(url, '_self');
  win.focus();
}

export async function buildUrlAndOpenSameWindowNew(url) {
  if (url.startsWith(Config.staticWebSiteUrl)) {
    const relativeUrl = url.replace(Config.staticWebSiteUrl, '');
    const contentLoad = await EpiContext.loadContentByPath(relativeUrl);
    if (contentLoad?.url) {
      EpiContext.navigateTo(contentLoad.url).then(() => {
        if (typeof window.scrollTo === 'function') {
          window.scrollTo(0, 0);
        }
      });
    }
    return;
  }
  if (!validURL(url)) {
    const relativeUrl = url?.toLowerCase();
    if (relativeUrl.includes('/globalassets') || relativeUrl.includes('/contentassets')) {
      url = EpiContext.getEpiserverUrl() + url;
    } else {
      let content = await EpiContext.loadContentByPath(url);
      url = Config.staticWebSiteUrl + content.url;
    }
  }
  let win = window.open(url, '_self');
  win.focus();
}

// export async function buildUrlAndNavigate(url) {
//   //the function tries to load url (MUST BE A RELATIVE PATH) and navigates through Epi
//   try {
//     url = url.replaceAll('https://', '').replaceAll('http://', '');
//     url = url.substring(url.indexOf('/'));
//     if (url != '') {
//       const contentLoad = await EpiContext.loadContentByPath(url);
//       if (contentLoad?.url) {
//         EpiContext.navigateTo(url);
//         return;
//       }
//     }
//   } catch (e) {}
//   EpiContext.navigateTo('/');
// }

export async function buildUrlAndNavigate(url ,noHistory = false) {
  try {
    url = url.replaceAll('https://', '').replaceAll('http://', '');
    url = url.substring(url.indexOf('/'));
    if (url != '') {
      const urlObj = new URL(url, window.location.origin);
      const pathWithoutQuery = urlObj.pathname;
      const queryParams = urlObj.search;

      const contentLoad = await EpiContext.loadContentByPath(pathWithoutQuery);
      if (contentLoad?.url) {
        if (!queryParams) {
          EpiContext.navigateTo(pathWithoutQuery, noHistory);
        } else {
          await EpiContext.navigateTo(pathWithoutQuery, noHistory);
          let newUrl = pathWithoutQuery + queryParams;
          window.history.pushState({}, '', newUrl);
        }
        return;
      }
    }
  } catch (e) {}
  EpiContext.navigateTo('/');
}

export async function buildUrlAndOpenSameWindowWithParams(url, params) {
  if (!validURL(url)) {
    if (url.startsWith('/globalassets')) {
      url = EpiContext.getEpiserverUrl() + url;
    } else {
      let content = await EpiContext.loadContentByPath(url);
      url = Config.staticWebSiteUrl + content.url;
    }
    url = new URL(url);
  } else {
    url = new URL(url, window.location.origin);
  }

  if (params) {
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        url.searchParams.append(key, params[key]);
      }
    }
  }

  let win = window.open(url, '_self');
  win.focus();
}

export function navigateTo(url) {
  if (!validURL(url)) {
    EpiContext.navigateTo(url);
    return;
  }
  let win = window.open(url, '_self');
  win.focus();
}

export function numWithStarRTL(str) {
  if (str.indexOf('*') === 0) {
    str = str.split('').splice(1, str.length).join('') + '*';
  }
  return str;
}

String.prototype.replaceAt = function (index, replacement) {
  return this.substr(0, index) + replacement + this.substr(index + replacement.length);
};

export function objectIsEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }
  return JSON.stringify(obj) === JSON.stringify({});
}

export function createGuid() {
  var guidHolder = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  var hex = '0123456789abcdef';
  var r = 0;
  var guidResponse = '';

  for (var i = 0; i < 36; i++) {
    if (guidHolder[i] !== '-' && guidHolder[i] !== '4') {
      // each x and y needs to be random
      r = (Math.random() * 16) | 0;
    }

    if (guidHolder[i] === 'x') {
      guidResponse += hex[r];
    } else if (guidHolder[i] === 'y') {
      // clock-seq-and-reserved first hex is filtered and remaining hex values are random
      r &= 0x3; // bit and with 0011 to set pos 2 to zero ?0??
      r |= 0x8; // set pos 3 to 1 as 1???
      guidResponse += hex[r];
    } else {
      guidResponse += guidHolder[i];
    }
  }
  return guidResponse;
}

export function convertSlotDataToDlvDate(slotData) {
  const dateSplitted = slotData.split('-');
  const formattedDate = `${dateSplitted[0]}${dateSplitted[1]}${dateSplitted[2]}`;
  return formattedDate;
}

export function convertDateTimeToDate(dateString) {
  //return DD.MM.YYYY

  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}
export const formatDateString14digits = (dateString) => {
  //string format: from yyyyMMddhhmmss to dd/MM/yyyy
  return `${dateString.substring(6, 8)}/${dateString.substring(4, 6)}/${dateString.substring(0, 4)}`;
};
export const formatTimeString14digits = (dateString) => {
  //string format: from yyyyMMddhhmmss to hh:mm:ss
  return `${dateString.substring(8, 10)}:${dateString.substring(10, 12)}:${dateString.substring(12, 14)}`;
};

export function removeHTMLTags(html) {
  // Regular expression to match HTML tags
  try {
    var regex = /<[^>]+>/g;
    if (html === null || html === undefined) return;
    // Remove HTML tags from the input string
    var plainText = html.replace(regex, '');
    return plainText;
  } catch (e) {
    console.log(e);
    return '';
  }
}

export function removeHtmlTagsAndEntities(html) {
  if (typeof html !== 'string' || !html.trim()) {
    return '';
  }
  try {
    let text = html.replace(/<[^>]*>/g, '');
    text = text.replace(/&[a-zA-Z0-9#]+;/g, '');
    return text.replace(/\n/g, ' ').trim();
  } catch (error) {
    return '';
  }
}

export function navigateToUrl(url) {
  if (!validURL(url)) {
    EpiContext.navigateTo(url);
    return;
  }
  let win = window.open(url, '_self');
  win.focus();
}

export function extractBaseUrl(url) {
  var parsedUrl = new URL(url);
  var baseUrl = parsedUrl.origin + parsedUrl.pathname;
  return baseUrl;
}

export function formatPhoneNumber(phoneNumber) {
  return `${phoneNumber.slice(0, 2)}x-xxxx${phoneNumber.slice(7)}`;
}

export function formatPhone(phoneNumber) {
  if (!phoneNumber) return '';
  const digits = String(phoneNumber).replace(/[^0-9]/g, '');
  return `${digits.slice(0, 3)}-${digits.slice(3)}`;
}

export function isNonEmptyString(str) {
  return typeof str === 'string' && str.trim().length > 0;
}

export function isTokenIsValidForProcess(userToken, userTokenRoles, relevantRole) {
  if (isNonEmptyString(userToken)) {
    return isTokenHasRelevantRole(userTokenRoles, relevantRole);
  }
  return false;
}

export function isTokenHasRelevantRole(userTokenRoles, relevantRole) {
  if (Array.isArray(userTokenRoles) && relevantRole) {
    if (typeof relevantRole === 'string') {
      return userTokenRoles.includes(relevantRole);
    }
    if (Array.isArray(relevantRole)) {
      return relevantRole.some((item) => userTokenRoles.includes(item));
    }
    return false;
  }
  return false;
}

export function isNullOrEmpty(obj) {
  return (
    obj == null ||
    obj == undefined ||
    obj == '' ||
    (obj != null && typeof obj === 'object' && Object.keys(obj).length === 0) ||
    (obj != null && Array.isArray(obj) && obj.length === 0)
  );
}

export function insertAt(str, index, char) {
  return str?.slice(0, index) + char + str?.slice(index);
}


export function getDataFromIContentRepo(fieldName) {
  var state = EpiContext.getStore().getState()?.iContentRepo;
  const ref = state?.refs?.startPage;
  return state?.items?.[ref]?.content?.[fieldName].value;
}
